module.exports = __webpack_public_path__ + "static/img/headerFooterOn.308f03db.svg";